<div
  class="w-full h-full rounded-xl card-result-small-{{variant()}} transition-shadow duration-300"
  [class.hover:cursor-pointer]="link()"
  [class.hover:shadow-xl]="link()"
  (click)="openLinkAndRedirect()"
>
  @if(image()){
  <img
    [src]="image()"
    alt="Result"
    class="h-[12rem] w-full object-cover rounded-t-xl"
  />
  }
  <div class="flex flex-col justify-between p-6 w-full h-full min-h-[13rem]">
    <h4>{{ title() }}</h4>
    <p class="font-thin">{{ text() }}</p>
    <button
      class="cta"
      (click)="$event.stopPropagation(); openLinkAndRedirect()"
    >
      {{'components.cardResult.discover' | transloco }}<icon
        [name]="'arrow-right'"
        [size]="'0.875rem'"
      ></icon>
    </button>
  </div>
</div>
